export function buildLiveSetupCacheSnapshotKey({
  useDesignSetupFlow = false,
  liveNeedsFreshServerState = false,
  queryAccountId = "",
  storedAccountId = "",
  liveMode = "existing",
  liveStep = "preferences",
} = {}) {
  return JSON.stringify({
    useDesignSetupFlow: useDesignSetupFlow === true,
    liveNeedsFreshServerState: liveNeedsFreshServerState === true,
    queryAccountId: String(queryAccountId || "").trim(),
    storedAccountId: String(storedAccountId || "").trim(),
    liveMode: String(liveMode || "").trim() || "existing",
    liveStep: String(liveStep || "").trim() || "preferences",
  });
}

export function readLiveSetupCacheSnapshot({
  useDesignSetupFlow = false,
  liveNeedsFreshServerState = false,
  queryAccountId = "",
  storedAccountId = "",
  readCachedPreferencesBootstrap = () => null,
  readCachedMyAccount = () => null,
  readCachedBillingSubscription = () => null,
  readCachedMyAccounts = () => null,
} = {}) {
  if (useDesignSetupFlow || liveNeedsFreshServerState) {
    return {
      account: null,
      billing: null,
      accountsPayload: null,
    };
  }

  const normalizedQueryAccountId = String(queryAccountId || "").trim();
  const normalizedStoredAccountId = String(storedAccountId || "").trim();

  return {
    account: (
      readCachedPreferencesBootstrap(normalizedQueryAccountId)
      || readCachedPreferencesBootstrap(normalizedStoredAccountId)
      || readCachedMyAccount(normalizedQueryAccountId)
      || readCachedMyAccount(normalizedStoredAccountId)
    ),
    billing: (
      readCachedBillingSubscription(normalizedQueryAccountId)
      || readCachedBillingSubscription(normalizedStoredAccountId)
      || null
    ),
    accountsPayload: readCachedMyAccounts() || null,
  };
}

export function getStableLiveSetupCacheSnapshot(currentState, options = {}) {
  const nextKey = buildLiveSetupCacheSnapshotKey(options);
  if (currentState?.key === nextKey) {
    return currentState;
  }

  return {
    key: nextKey,
    snapshot: readLiveSetupCacheSnapshot(options),
  };
}
